import { useState } from 'react';

export const useSorting = () => {
  // Rules sort state
  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const [rulesSort, setRulesSort] = useState({ type: 'priority', direction: 'asc' });

  // Transaction sort state
  const [txnSortAnchorEl, setTxnSortAnchorEl] = useState(null);
  const [txnSort, setTxnSort] = useState({ type: 'date', direction: 'desc' });

  const handleSortClick = (event) => {
    setSortAnchorEl(event.currentTarget);
  };
  const handleSortClose = () => {
    setSortAnchorEl(null);
  };
  const handleSortChange = (type, direction) => {
    setRulesSort({ type, direction });
    setSortAnchorEl(null);
  };

  const handleTxnSortClick = (event) => {
    setTxnSortAnchorEl(event.currentTarget);
  };
  const handleTxnSortClose = () => {
    setTxnSortAnchorEl(null);
  };
  const handleTxnSortChange = (type, direction) => {
    setTxnSort({ type, direction });
    setTxnSortAnchorEl(null);
  };

  return {
    rulesSort,
    handleSortClick,
    handleSortClose,
    handleSortChange,
    sortAnchorEl,
    txnSort,
    handleTxnSortClick,
    handleTxnSortClose,
    handleTxnSortChange,
    txnSortAnchorEl
  };
};